
export function setProjection(view: string): void {
    // @ts-ignore
    const iframe = window.containerRef?.current?.contentWindow;

    if (view === 'perspective') {
        iframe.ExitProjection();
    } else {
        iframe.SetProjection(view);
    }
} 